module.exports = __webpack_public_path__ + "img/roseiral_01.34ad6682.jpg";